import { initialClientRouteContextValue } from '../components/RouteContext';

import { createClientRoute } from './create-client-route';

import type { BaseRoute, ClientRouteContextValue } from '../types';

export function createClientRouteContext(
  routes: BaseRoute[]
): ClientRouteContextValue {
  return routes.reduce(
    (context, current) => {
      context[current.url] = createClientRoute(current);
      return context;
    },
    { ...initialClientRouteContextValue }
  );
}
